import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const DisclaimerPage = lazy(() => import('../pages/disclaimer/page'));
// Preload checkout page immediately - no lazy loading for faster navigation
import CheckoutPage from '../pages/checkout/page';
const ThankYouPage = lazy(() => import('../pages/thank-you/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/disclaimer',
    element: <DisclaimerPage />,
  },
  {
    path: '/checkout',
    element: <CheckoutPage />,
  },
  {
    path: '/thank-you',
    element: <ThankYouPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
